import {
    GET_ACTIVE_SERVICES_REQUEST,
    GET_ACTIVE_SERVICES_SUCCESS,
    GET_ACTIVE_SERVICES_FAILURE,
} from "../actions/active";

const initialState = {
    fetching: false,
    activeservices: null,
    totalActiveservices: 0
};

export default (state = initialState, action) => {
    switch (action.type) {
        case GET_ACTIVE_SERVICES_REQUEST: {
            return {
                ...state,
                fetching: true,
                activeservices: null
            };
        }
        case GET_ACTIVE_SERVICES_SUCCESS: {

            return {
                ...state,
                fetching: false,
                activeservices: action.payload.activeservices,
                totalActiveservices: action.payload.total
            };
        }
        case GET_ACTIVE_SERVICES_FAILURE: {
            return {
                ...state,
                fetching: false
            };
        }
        default:
            return state;
    }
};
